import clsx from 'clsx'
import { smsSegmentInfo, stripHtmlToText } from 'utils/html-text'

export interface SmsSegmentCounterProps {
	html: string
	className?: string
}

export function SmsSegmentCounter({ html, className }: SmsSegmentCounterProps) {
	const text = stripHtmlToText(html)
	const { segments } = smsSegmentInfo(text)
	const exceedsSingleSegment = segments > 1

	return (
		<div className={clsx('text-xs', exceedsSingleSegment ? 'text-warning' : 'text-secondary-text', className)}>
			{text.length.toLocaleString()} {text.length === 1 ? 'character' : 'characters'} ·{' '}
			{segments.toLocaleString()} SMS {segments === 1 ? 'segment' : 'segments'} (approx.)
		</div>
	)
}
